// @mui
import { GlobalStyles as GS } from '@mui/material';
import { padding } from '@mui/system';

export default function GlobalStyles() {
  return (
    <GS
      styles={(theme) => ({
        code: {
          borderRadius: 4,
          fontFamily: 'monospace',
          fontSize: '0.9em',
        },
        'pre code': {
          display: 'block',
          padding: '12px',
          whiteSpace: 'pre-wrap',
          lineHeight: 1.6,
          borderRadius: 1,
          overflowX: 'auto',
        },

        /* Chrome, Edge, Safari */
        '::-webkit-scrollbar': {
          width: 6,
          height: 6,
        },
        '::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '::-webkit-scrollbar-thumb': {
          backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[300],
          borderRadius: 10,
        },
        '::-webkit-scrollbar-thumb:hover': {
          backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.grey[400],
        },

        /* Firefox */
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor:
            theme.palette.mode === 'dark'
              ? `${theme.palette.grey[700]} transparent`
              : `${theme.palette.grey[300]} transparent`,
        },
      })}
    />
  );
}
